import React from 'react';

export const RegisterTable = {

  // Internal id of the component
  id: 'table',

  // Visible label
  label: 'Table',

  // Fields the user need to fill out when adding an instance of the component
  fields: [{
    name: 'data',
    label: 'Table',
    widget: 'table',
  }],

  // Pattern to identify a block as being an instance of this component
  // pattern: /^rentBuggy (\S+)$/,
  pattern: /<div class="table"( data-color="([a-zA-Z0-9_\-]*)")?( data-fullwidth="([a-zA-Z]*)")?( data-align-([0-9])*="([a-zA-Z]*)")*(\s)*><table>(.*)<\/table><\/div>/,

  // Function to extract data elements from the regexp match
  fromBlock(match) {
    return {
      data: match[0],
    };
  },

  // Function to create a text block from an instance of this component
  toBlock(obj) {
    return obj.data;
  },

  // Preview output for this component. Can either be a string or a React component
  // (component gives better render performance)
  toPreview(obj) {
    return (
      <Table>{obj.data}</Table>
    );
  },

};

// eslint-disable-next-line
export const Table = ({ children }) => (
  <div className="table-container" dangerouslySetInnerHTML={{ __html: children }} />
);
